import { render, staticRenderFns } from "./TalkDialog.vue?vue&type=template&id=77cd682f&scoped=true&"
import script from "./TalkDialog.vue?vue&type=script&lang=js&"
export * from "./TalkDialog.vue?vue&type=script&lang=js&"
import style0 from "./TalkDialog.vue?vue&type=style&index=0&id=77cd682f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cd682f",
  null
  
)

export default component.exports